import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_CFpUtZItT98p: {
	id: 'prd_CFpUt2DEV2ZItT98p'
	ident: 'prd_CFpUtZItT98p'
	sku: 'simple_premium_4w_6_79_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_fS9iU2DEV2kUcGAn9'
			amount: 44
			amount_usd: 6.79
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.79
			discount: 37.21
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_Kh9IJ2DEV2CQLn52M'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_CFpUtZItT98p, SubscriptionProduct>
const prd_CFpUtZItT98p = { ident: 'prd_CFpUtZItT98p' } as typeof _prd_CFpUtZItT98p

export default prd_CFpUtZItT98p
